import React from 'react';
import {
  INumberFieldProps,
  IButtonProps,
  Grid,
  Card,
  CardContent,
  GridColumn,
  Heading,
  Button,
  NumberField,
  Text,
  THeadingLevel,
  AnalyticsTrigger
} from 'telia-front-react';

interface TemplateSafeCalculatorProps {
  numberInput: INumberFieldProps;
  devicesTitle: string;
  resultTitle: string;
  resultPrice: string;
  resultRegularPrice: string;
  resultButton: IButtonProps;
  headingLevel?: THeadingLevel;
}

const TemplateSafeCalculator = (props: TemplateSafeCalculatorProps): JSX.Element => {
  const { numberInput, devicesTitle, resultTitle, resultPrice, resultRegularPrice, resultButton, headingLevel = 4 } = props;
  return (
    <Card>
      <CardContent>
        <Grid>
          <GridColumn width={['sm-6']}>
            <Text className="text-center">
              <Heading level={headingLevel}>{devicesTitle}</Heading>
              <NumberField {...numberInput} align="center" />
            </Text>
          </GridColumn>
          <GridColumn width={['sm-6']}>
            <Text className="text-center">
              <Heading level={headingLevel}>{resultTitle}</Heading>
              <strong className="h5">{resultPrice}</strong>
              <p className="text-light text__margin-none">{resultRegularPrice}</p>
              <AnalyticsTrigger trigger={{ id: 'CTA - Telia Safe', callback: 'onClick' }}>
                <Button {...resultButton} type="expressive" iconRight="#arrow-right" />
              </AnalyticsTrigger>
            </Text>
          </GridColumn>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TemplateSafeCalculator;
